import { createRouter, createRootRoute, createRoute, Outlet } from '@tanstack/react-router';
import { Layout } from './components/Layout';
import { LandingRoute } from './routes/Landing';
import { JoinRoute } from './routes/Join';
import { LoginRoute } from './routes/Login';
import { OwnerSetupRoute } from './routes/OwnerSetup';
import { PlayRoute } from './routes/Play';
import { PlayBotRoute } from './routes/PlayBot';
import { SettingsRoute } from './routes/Settings';
import { HelpRoute } from './routes/Help';
import { CardsRoute } from './routes/Cards';
import { ReplaysRoute } from './routes/Replays';
import { ReplayDetailRoute } from './routes/ReplayDetail';
import { SupportRoute } from './routes/Support';
import { CreditsRoute } from './routes/Credits';
import { NotFoundRoute } from './routes/NotFound';
import { GameRoute } from './routes/Game';
import { OnlineGameRoute } from './routes/OnlineGame';
import { InviteRoute } from './routes/Invite';
import { ProfileRoute } from './routes/Profile';
import { DocPageRoute } from './routes/DocPage';

const rootRoute = createRootRoute({
  component: () => (
    <Layout>
      <Outlet />
    </Layout>
  ),
  notFoundComponent: NotFoundRoute,
});

const landingRoute = createRoute({ getParentRoute: () => rootRoute, path: '/', component: LandingRoute });
const joinRoute = createRoute({ getParentRoute: () => rootRoute, path: '/join', component: JoinRoute });
const loginRoute = createRoute({ getParentRoute: () => rootRoute, path: '/login', component: LoginRoute });
const ownerSetupRoute = createRoute({ getParentRoute: () => rootRoute, path: '/owner-setup', component: OwnerSetupRoute });
const playRoute = createRoute({ getParentRoute: () => rootRoute, path: '/play', component: PlayRoute });
const playBotRoute = createRoute({ getParentRoute: () => rootRoute, path: '/play/bot', component: PlayBotRoute });
const inviteRoute = createRoute({ getParentRoute: () => rootRoute, path: '/invite/$slug', component: InviteRoute });
const settingsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/settings', component: SettingsRoute });
const helpRoute = createRoute({ getParentRoute: () => rootRoute, path: '/help', component: HelpRoute });
const cardsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/cards', component: CardsRoute });
const replaysRoute = createRoute({ getParentRoute: () => rootRoute, path: '/replays', component: ReplaysRoute });
const replayDetailRoute = createRoute({ getParentRoute: () => rootRoute, path: '/replays/$gameId', component: ReplayDetailRoute });
const supportRoute = createRoute({ getParentRoute: () => rootRoute, path: '/support', component: SupportRoute });
const creditsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/credits', component: CreditsRoute });
const gameRoute = createRoute({ getParentRoute: () => rootRoute, path: '/game', component: GameRoute });
const onlineGameRoute = createRoute({ getParentRoute: () => rootRoute, path: '/game/$gameId', component: OnlineGameRoute });
const profileRoute = createRoute({ getParentRoute: () => rootRoute, path: '/profile/$username', component: ProfileRoute });
const docPageRoute = createRoute({ getParentRoute: () => rootRoute, path: '/docs/$slug', component: DocPageRoute });

const routeTree = rootRoute.addChildren([
  landingRoute,
  joinRoute,
  loginRoute,
  ownerSetupRoute,
  playRoute,
  playBotRoute,
  inviteRoute,
  settingsRoute,
  helpRoute,
  cardsRoute,
  replaysRoute,
  replayDetailRoute,
  supportRoute,
  creditsRoute,
  gameRoute,
  onlineGameRoute,
  profileRoute,
  docPageRoute,
]);

export const router = createRouter({ routeTree, defaultPreload: 'intent' });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
